/** Single source of truth for Reason column badges (invoices feed + help modal). */
export const INVOICE_REASON_FLAG_CONFIG = {
    ro: {
        key: 'ro',
        label: 'RO',
        colorScheme: 'partbay-blue',
        tooltip: 'RO is missing or not found in NEX.',
    },
    nex: {
        key: 'nex',
        label: 'Match',
        colorScheme: 'orange',
        tooltip: 'One or more line items need NEX match review.',
    },
    math: {
        key: 'math',
        label: 'MATH',
        colorScheme: 'purple',
        tooltip: 'Arithmetic or totals calculation mismatch detected.',
    },
    dupe: {
        key: 'dupe',
        label: 'DUPE',
        colorScheme: 'yellow',
        tooltip:
            'Duplicate invoice: already submitted in Yaxle for this vendor, invoice number, and type (change the number if this is a different document, then submit), or Nexsyis returned HTTP 406.',
    },
    vendor: {
        key: 'vendor',
        label: 'VENDOR',
        colorScheme: 'teal',
        tooltip: 'Invoice vendor does not match NEX vendor data.',
    },
    specialVendor: {
        key: 'specialVendor',
        label: 'Special Vendor',
        /** Rendered as brown in `InvoiceReasonFlagBadge` (no native Chakra `brown` scheme). */
        colorScheme: 'brown',
        tooltip: 'Resolved supplier matched your organization’s flagged-vendor list (by supplier id). Automatic submit was stopped for review; you can still submit manually.',
    },
    locationMismatch: {
        key: 'locationMismatch',
        label: 'SHOP',
        colorScheme: 'orange',
        tooltip:
            'The extracted RO/PO aligns with a repair that is not at the location assigned to the person who uploaded the invoice. Automatic submit was stopped for review; you can still submit manually.',
    },
    stale: {
        key: 'stale',
        label: 'STALE',
        colorScheme: 'gray',
        tooltip:
            'The extracted RO/PO contains parts from more than one year ago. Automatic submit was stopped for review; you can still submit manually after you confirm.',
    },
    price: {
        key: 'price',
        label: 'PRICE',
        colorScheme: 'pink',
        tooltip: 'Unit or list price does not match NEX.',
    },
    discount: {
        key: 'discount',
        label: 'DISCOUNT',
        colorScheme: 'partbay-blue',
        tooltip: 'Line item discount (list vs buy) is below the expected discount configured for this insurer, vendor, and state.',
    },
    qty: {
        key: 'qty',
        label: 'QTY',
        colorScheme: 'cyan',
        tooltip: 'Quantity does not match NEX.',
    },
    total: {
        key: 'total',
        label: 'AMOUNT',
        colorScheme: 'red',
        tooltip: 'Amount mismatch: line or extended total does not match NEX.',
    },
} as const;

export type InvoiceReasonFlagKey = keyof typeof INVOICE_REASON_FLAG_CONFIG;

export const NUMERIC_REASON_BADGE_SCHEME = 'gray';
